<template>
  <div class="content" style="padding-bottom: 50px;">
    <div class="wrapper">
      <div class="tabs-wrapper" v-if="categories">
        <div class="tabs-mark-group">
          <span class="title">所有分类：</span>
          <ul class="">
            <li v-if="selectedCategory">
              {{ selectedCategory.name }}<i class="el-icon-arrow-right"></i>
            </li>
            <li v-if="selectedSubCategory">
              {{ selectedSubCategory.name }}<i class="el-icon-arrow-right"></i>
            </li>
            <li v-if="selectedthirdLevelCategory">
              {{ selectedthirdLevelCategory.name
              }}<i class="el-icon-arrow-right"></i>
            </li>
            <li v-for="(tag, index) in tags" :key="index">
              <el-tag closable type="info" effect="plain" @close="handleClose(index)">
                {{ tagGroups[index]["subs"][tag].name }}
              </el-tag>
            </li>
          </ul>
        </div>
        <div class="tabs-group cate" v-if="subCategories && !Array.isArray(categories)">
          <span class="title">分类：</span>
          <ul class="">
            <li @click="editCategory('category', '')" :class="activeClass('selectedCategory', 'all')">
              全部
            </li>
            <li v-for="item in categories" @click="editCategory('category', item.code)" :class="activeClass('selectedCategory', item.code)" :key="item.id">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="tabs-group cate" v-if="subCategories && !Array.isArray(subCategories)">
          <ul class="">
            <li @click="editCategory('subCategory', '')" :class="activeClass('selectedSubCategory', 'all')">
              全部
            </li>
            <li v-for="item in subCategories" @click="editCategory('subCategory', item.code)" :class="activeClass('selectedSubCategory', item.code)" :key="item.id">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="tabs-group cate" v-if="thirdLevelCategories && !Array.isArray(thirdLevelCategories)">
          <ul class="">
            <li @click="editCategory('thirdLevelCategory', '')" :class="activeClass('selectedthirdLevelCategory', 'all')">
              全部
            </li>
            <li v-for="item in thirdLevelCategories" @click="editCategory('thirdLevelCategory', item.code)" :class="activeClass('selectedthirdLevelCategory', item.code)"
              :key="item.id">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div v-for="(tagGroup, index) in tagGroups" :key="index">
          <!-- 条件：不在选中的标签组和训练的标签组 -->
          <div class="tabs-group tab" v-if="Object.keys(tags).indexOf(index) == -1 && tagGroup.scope.indexOf('classroom')>-1  && Object.keys(tagGroup.subs).length>0">
            <div class="title">{{ tagGroup.name }}：</div>
            <ul>
              <li v-for="tag in tagGroup.subs" :key="tag.id">
                <el-tag type="info" effect="plain" @click="editTag(index, tag.id)">{{ tag.name }}</el-tag>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="contest-wrapper">
        <div class="training_item" v-for="item in classrooms" :key="item.id" @click="(detail(item.id))">
          <div class="title">{{ item.title }}</div>
          <div class="info">
            <div class="divider"></div>
            <p class="desc" v-html="item.about">{{ item.about }}</p>
            <span class="num"><i class="el-icon-menu"></i>{{item.courseNum}} 个</span>
            <span class="num"><i class="el-icon-s-flag"></i>{{competitionDataArr[item.id]['total_items']}} 活动</span>
            <span class="num"><i class="el-icon-s-order"></i>{{competitionDataArr[item.id]['total_topics']}} 题</span>
          </div>
          <img :src="common.filepath(item.middlePicture)" alt="" class="cover" />

        </div>

      </div>
      <el-pagination @current-change="pageChange" background layout="total, prev, pager, next" :total="paginator.itemCount" :page-size="20" v-show="paginator" v-if="paginator"
        hide-on-single-page></el-pagination>
    </div>
  </div>
</template>

<script>
import { getClassroomIndex, joinClassroom } from "@/api/classroom";
import CountDown from "@/components/CountDown.vue";
import EntryForm from "@/components/EntryForm.vue";
export default {
  components: {
    CountDown,
    EntryForm
  },
  data() {
    return {
      code: "",
      classrooms: [],
      competitionDataArr: null,
      category: "",
      subCategory: "",
      thirdLevelCategory: "",
      selectedCategory: null,
      selectedSubCategory: null,
      selectedthirdLevelCategory: null,
      categories: null,
      subCategories: null,
      thirdLevelCategories: null,
      tagGroups: null,
      tags: null,
      coursesMember: null,
      teachers: null,
      coursesLockedMember: null,
      selectedTags: null,
      trainData: null,
      page: 1,
      paginator: null,
      userId: "",
      show: true,
      btnStatus: {},
    };
  },
  created() {
    // this.handle();
  },
  watch: {
    category() {
      this.subCategory = "";
      this.thirdLevelCategory = "";
      this.handle();
    },
    subCategory() {
      this.thirdLevelCategory = "";
      this.handle();
    },
    thirdLevelCategory() {
      this.handle();
    },
    selectedTags: {
      handler: "handle",
      immediate: true,
      deep: true
    }
  },
  methods: {
    //获取竞赛数据列表
    handle() {
      var id = 1;
      var params = {
        subCategory: this.subCategory,
        selectedthirdLevelCategory: this.thirdLevelCategory,
        "filter[type]": "all",
        "filter[price]": "all",
        "filter[currentLevelId]": "all",
        // "tag[tags][1]": 6,
        // "tag[tags][2]": 17,
        page: this.page,
        type: "classroom"
      };
      for (let key in this.selectedTags) {
        params["tag[tags][" + key + "]"] = this.selectedTags[key];
      }

      getClassroomIndex(this.category, params).then(response => {
        this.classrooms = response.data.classrooms;
        this.competitionDataArr = response.data.competitionDataArr;
        this.categories = response.data.categoryNav.categories;
        this.subCategories = response.data.categoryNav.subCategories;
        this.thirdLevelCategories =
          response.data.categoryNav.thirdLevelCategories;
        this.selectedCategory = response.data.categoryNav.selectedCategory;
        this.selectedSubCategory =
          response.data.categoryNav.selectedSubCategory;
        this.selectedthirdLevelCategory =
          response.data.categoryNav.selectedthirdLevelCategory;
        this.tags = response.data.tags;
        // this.coursesMember = response.data.coursesMember;
        // this.trainData = response.data.trainData;
        // this.coursesLockedMember = response.data.coursesLockedMember;
        // this.teachers = response.data.teachers;
        // this.userId = response.data.userId;
        this.paginator = response.data.paginator;
        var tagGroups = response.data.categoryNav.tagGroups;
        var tagArr = response.data.categoryNav.tags;
        var tagGroupArr = {};
        for (let i = 0; i < tagGroups.length; i++) {
          tagGroupArr[tagGroups[i].id] = tagGroups[i];
        }
        this.tagGroups = tagGroupArr;
      });
    },

    detail(id) {
      this.$router.push({
        name: "classroom-path",
        params: { classroomId: id }
      });
    },

    pageChange(val) {
      this.page = val;
      this.handle();
    },
    editCategory(level, code) {
      this[level] = code;
    },
    editTag(group, id) {
      this.selectedTags = { ...this.tags };
      this.selectedTags[group] = id;
    },
    activeClass(level, code) {
      if (this[level] && this[level]["code"] == code) {
        return "active";
      } else if (!this[level] && code == "all") {
        return "active";
      } else {
        return "";
      }
    },
    handleClose(group) {
      var tags = { ...this.selectedTags };
      delete tags[group];
      this.selectedTags = tags;
    },
  },
  filters: {

  }
};
</script>

<style scoped lang="less">
.carousel {
  .banner {
    width: 100%;
    height: 300px;
  }
}
.wrapper {
  width: 1000px;
  margin: 20px auto 0;
  ul li {
    display: inline-block;
  }
  .tabs-wrapper {
    border: 1px solid #d7d7d7;
    border-radius: 4px;
    margin-bottom: 30px;
    background-color: #fff;
    box-sizing: border-box;
    ul {
      margin-left: 120px;
    }
    .active {
      background-color: #229eff;
      color: #fff;
    }
    li {
      margin-right: 20px;
    }
    .tabs-mark-group {
      height: 44px;
      line-height: 44px;
      li {
        padding-left: 5px;
        padding-right: 5px;
      }
      .title {
        width: 100px;
        padding: 12px 10px;
        float: left;
        line-height: 20px;
      }
    }
    .tabs-group {
      line-height: 50px;

      border-top: 1px dashed #d7d7d7;
      .el-tag {
        cursor: pointer;
        color: #000;
      }
    }
    .cate li {
      margin: 10px 0;
      padding: 0 11px;
      line-height: 30px;
      border-radius: 5px;
      cursor: pointer;
    }
    .title {
      float: left;
      padding: 15px 10px;
      width: 100px;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: normal;
      line-height: 20px;
    }
    .tab {
      background: rgb(245, 245, 245);
      border-top: 1px solid #d7d7d7;
    }
  }
  .contest-wrapper {
    .training_item {
      width: 490px;
      height: auto;
      padding: 20px;
      margin-bottom: 20px;
      border: 1px solid #d7d7d7;
      box-sizing: border-box;
      color: #7f7f7f;
      float: left;
      cursor: pointer;
      border-radius: 5px;
      &:nth-child(2n + 1) {
        margin-right: 20px;
      }
      & > * {
        float: left;
      }
      .info {
        width: 328px;
        .divider {
          width: 30px;
          height: 6px;
          background-color: rgb(255, 110, 26);
          border-radius: 5px;
          margin: 10px 0;
        }
      }
      .cover {
        width: 100px;
        height: 100px;
        margin-left: 20px;
        border-radius: 50%;
      }
      .title {
        width: 100%;
        font-size: 18px;
        font-weight: 700;
        line-height: 22px;
        color: #000;
      }
      .progress {
        line-height: 22px;
        float: right;
      }
      .desc {
        width: 100%;
        height: 60px;
        line-height: 20px;
        margin-bottom: 15px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
      .num {
        text-align: left;
        display: inline-block;
        width: 33%;
        box-sizing: border-box;
        font-size: 14px;
        i {
          font-size: 20px;
        }
      }
      // .num:last-child{
      //   border-right: none;
      // }
      // .el-divider--horizontal{
      //   margin: 15px 0
      // }
    }
  }
}
</style>
